import {
  ApiClientError,
  GetV4ReportingDevicesResponse,
} from '@raydiant/api-client-js';

import { keys } from '../queryClient';
import raydiant from '../clients/miraClient';
import useProtectedQuery from './useProtectedQuery';

export default function useReportingDevices() {
  return useProtectedQuery<GetV4ReportingDevicesResponse, ApiClientError>(
    keys.reportingDevices(),
    () => raydiant.getV4ReportingDevices(),
  );
}
